import React, { useState } from 'react'
import { filtrarOpcoes, Opcao } from './comum'
import './solicitacoes.scss'

interface Props {
  /** Os ambientes que existem nos pedidos da tela. */
  opcoes: Opcao[]
  /** O id do ambiente escolhido, ou '' para todos. */
  valor: string
  aoMudar: (id: string) => void
}

/** Filtro de ambiente para a barra de filtros: abre com todos, filtra pelo que se digita e mostra o escolhido no próprio campo. */
export default function FiltroAmbiente({ opcoes, valor, aoMudar }: Props) {
  const [aberto, setAberto] = useState(false)
  const [termo, setTermo] = useState('')
  const escolhido = opcoes.find(o => String(o.id) === valor)
  const achadas = filtrarOpcoes(opcoes, termo)

  const escolher = (id: string) => {
    aoMudar(id)
    setTermo('')
    setAberto(false)
  }

  return (
    <div className="sol-filtro-busca">
      <input
        className="ng-select"
        value={aberto ? termo : escolhido?.nome || ''}
        onChange={e => { setTermo(e.target.value); setAberto(true) }}
        onFocus={() => { setTermo(''); setAberto(true) }}
        onBlur={() => setTimeout(() => setAberto(false), 150)}
        placeholder="Todos os ambientes"
        aria-label="Ambiente"
        autoComplete="off"
      />
      {aberto && (
        <div className="sol-opcoes" role="listbox">
          {!termo.trim() && (
            <button type="button" role="option" aria-selected={!valor} className="sol-opcao" onMouseDown={e => e.preventDefault()} onClick={() => escolher('')}>
              <b>Todos os ambientes</b>
            </button>
          )}
          {achadas.length === 0 && <div className="sol-opcao vazio">Nenhum ambiente com esse nome.</div>}
          {achadas.map(o => (
            <button type="button" key={o.id} role="option" aria-selected={String(o.id) === valor} className="sol-opcao" onMouseDown={e => e.preventDefault()} onClick={() => escolher(String(o.id))}>
              <b>{o.nome}</b>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
